import { __assign } from "tslib";
import * as React from 'react';
import Popper from '@material-ui/core/Popper/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { CalendarPopover } from 'wix-ui-tpa';
import ScreenReaderOnly from '../../ScreenReaderOnly/ScreenReaderOnly';
import { makeStyles } from '@material-ui/core/styles';
import { st, classes } from './Popper.st.css';
export var CalendarPopoverChildren = function (_a) {
    var calendarPopoverClass = _a.calendarPopoverClass, isMobile = _a.isMobile, title = _a.title, handleCloseClick = _a.handleCloseClick, _b = _a.isCloseFocused, isCloseFocused = _b === void 0 ? false : _b, children = _a.children;
    return (
    //@ts-ignore
    React.createElement(CalendarPopover, { className: st(classes[calendarPopoverClass], { isMobile: isMobile }), isShown: true, withArrow: false, title: title, onClose: handleCloseClick, manualFocus: !isCloseFocused },
        React.createElement("div", { className: classes.child__wrapper, style: {
                paddingRight: "".concat(isMobile ? '0' : '32px'),
                overflow: 'hidden',
                display: 'flex',
            } }, children)));
};
var CustomePopper = function (_a) {
    var _b;
    var placement = _a.placement, open = _a.open, anchorEl = _a.anchorEl, handleClickAway = _a.handleClickAway, title = _a.title, handleCloseClick = _a.handleCloseClick, children = _a.children, _c = _a.popperStyle, popperStyle = _c === void 0 ? {} : _c, _d = _a.calendarPopoverClass, calendarPopoverClass = _d === void 0 ? '' : _d, isMobile = _a.isMobile, _e = _a.modifiers, modifiers = _e === void 0 ? null : _e, _f = _a.childrenDependencies, childrenDependencies = _f === void 0 ? {} : _f, _g = _a.isCloseFocused, isCloseFocused = _g === void 0 ? false : _g;
    //@ts-ignore
    var firstButton = React.useRef();
    //@ts-ignore
    var lastButton = React.useRef();
    var useStyles = makeStyles({
        Popper: __assign(__assign({}, popperStyle), (_b = {}, _b['z-index'] = '9999', _b)),
    });
    var styles = useStyles();
    var onFirstReached = function (e) {
        if (e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            lastButton.current.focus();
        }
    };
    var onLastReached = function (e) {
        if (!e.shiftKey && e.key === 'Tab') {
            e.preventDefault();
            firstButton.current.focus();
        }
    };
    return (React.createElement(Popper
    //@ts-ignore
    , { 
        //@ts-ignore
        modifiers: modifiers, className: styles.Popper, placement: placement, open: open, anchorEl: anchorEl, role: "dialog" },
        React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
            React.createElement("div", null,
                React.createElement(ScreenReaderOnly, null,
                    React.createElement("button", { className: classes.FirstButton, ref: firstButton, onKeyDown: onFirstReached })),
                React.createElement("div", null,
                    React.createElement(CalendarPopoverChildren, { calendarPopoverClass: calendarPopoverClass, isMobile: isMobile, title: title, handleCloseClick: handleCloseClick, children: children, isCloseFocused: isCloseFocused })),
                React.createElement(ScreenReaderOnly, null,
                    React.createElement("button", { className: classes.LastButton, ref: lastButton, onKeyDown: onLastReached }))))));
};
var areEqual = function (prevProps, nextProps) {
    if (nextProps.open || prevProps.open) {
        return false;
    }
    return true;
};
export default React.memo(CustomePopper, areEqual);
//# sourceMappingURL=Popper.js.map